/**
* @Author: Daniel Rhees <Daniel>
* @Date:   2017-01-21T19:19:46-08:00
* @Email:  daniel@reflexmedia.com
 * @Last modified by:   Daniel
 * @Last modified time: 2017-04-12T14:06:25-07:00
*/



import React from 'react';
import { StyleSheet, css } from 'aphrodite/no-important';
import { type, spacing } from '../../style';

const style = StyleSheet.create({
  loading: {
    ...spacing.MARGIN_TOP_SM,
    ...spacing.PADDING_H,
    ...type.LG,
    textAlign: 'center',
  },
});

const LoadingMsg = (props) => {

  let {
    msg
  } = props

  return (
    <div className={css(style.loading)}>
      {msg}...
    </div>
  )
}



export default LoadingMsg;



// WEBPACK FOOTER //
// ./src/components/common/LoadingMsg.jsx